import { Component, effect, inject, input, output, signal } from '@angular/core'
import { BndButton, BndModal } from '@bonduelle-it/storybook'
import { TranslatePipe, TranslateService } from '@ngx-translate/core'
import { Observable } from 'rxjs'
import { ToastService } from '../../services'

export interface AoConfirmDialogData {
  title?: string
  message: string
  confirmButtonLabel?: string
  cancelButtonLabel?: string
  displayCancelButton?: boolean
  confirmObservable?: Observable<unknown>
}

@Component({
  selector: 'ao-confirm-dialog',
  templateUrl: './ao-confirm-dialog.component.html',
  imports: [BndModal, BndButton, TranslatePipe],
})
export class AoConfirmDialogComponent {
  public readonly open = input(false)
  public readonly data = input<AoConfirmDialogData | null>()
  public result = output<boolean>()

  protected readonly isLoading = signal(false)

  private toastService = inject(ToastService)
  private translateService = inject(TranslateService)

  constructor() {
    effect(() => {
      if (this.open()) {
        this.isLoading.set(false)
      }
    })
  }

  onConfirm(): void {
    if (this.isLoading()) {
      return
    }
    const confirmObservable = this.data()?.confirmObservable
    if (!confirmObservable) {
      this.result.emit(true)
      return
    }
    this.isLoading.set(true)
    confirmObservable.subscribe({
      next: () => this.result.emit(true),
      error: () => {
        this.toastService.showToastError(this.translateService.instant('ERROR.GENERIC'))
        this.isLoading.set(false)
      },
    })
  }

  onCancel(): void {
    this.result.emit(false)
  }
}
